import React, { useState, useEffect } from "react";
import displayPicture from "../../assets/overview1.png";
import { setToken, verifyLogin } from "../utilities/authHelper";
import { useNavigate } from "react-router-dom";
import NavBarComponent from "../Dashboard/Common/navbar";
import LoadingOverlay from "../Dashboard/Common/LoadingOverlay";
import { Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Assuming you're using react-icons for the eye icons

function Login() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (verifyLogin()) {
      navigate("/home");
    }
  }, [navigate]);

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(`${apiUrl}/auth:login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (!response.ok) {
        setErrorMessage("" + data.detail);
        throw new Error(`Error: ${response.status}`);
      } else {
        if (data.results.access_token) {
          setToken(
            data.results.access_token,
            data.results.user_id,
            data.results.role
          );
          navigate("/home");
        }
      }
    } catch (error) {
      console.log("error", error);
      console.log("Login Failed");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <>
      <div className="row" style={{ height: "100%" }}>
        {isLoading ? (
          <LoadingOverlay />
        ) : (
          <>
            <div className="">
              <NavBarComponent isUserLoggedIn={verifyLogin()} />
              </div>
            <section className="bg-white" style={{ height: "95%" }}>
              <div className="container h-50 bg-white">
                <div className="row d-flex justify-content-center align-items-center h-100 mt-5">
                  <div className="col-lg-12 col-xl-11">
                    <div className=" text-black">
                      <div className=" p-md-5 shadow-lg rounded-4  ">
                        <div className="row justify-content-center">
                          <div className="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
                            <p className="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">
                              Log In
                            </p>

                            <form
                              className="mx-1 mx-md-4"
                              onSubmit={handleSubmit}
                            >
                              <div className="d-flex flex-row align-items-center mb-4">
                                <div className="form-floating flex-fill mb-1">
                                  <input
                                    type="email"
                                    value={email}
                                    id="form3Example3c"
                                    name="form3Example3c"
                                    className="form-control"
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    placeholder="Your Email"
                                  />
                                  <label
                                    className="form-label"
                                    htmlFor="form3Example3c"
                                  >
                                    <i className="fas fa-envelope fa-lg me-3 fa-fw"></i>
                                    Your Email
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex flex-row align-items-center mb-4">
                                <div className="form-floating flex-fill mb-0">
                                  <input
                                    type={passwordShown ? "text" : "password"}
                                    value={password}
                                    id="form3Example4c"
                                    className="form-control"
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                    required
                                    placeholder="Password"
                                  />
                                  <label
                                    className="form-label"
                                    htmlFor="form3Example4c"
                                  >
                                    <i className="fas fa-lock fa-lg me-3 fa-fw"></i>
                                    Password
                                  </label>
                                  <Button
                                    variant="outline-secondary"
                                    className="position-absolute end-0 top-50 translate-middle-y me-2"
                                    onClick={togglePasswordVisibility}
                                    style={{
                                      border: "none",
                                      background: "none",
                                      color: "inherit",
                                    }}
                                  >
                                    {passwordShown ? <FaEyeSlash /> : <FaEye />}
                                  </Button>
                                </div>
                              </div>
                              {errorMessage !== "" && (
                                <div className="d-flex flex-row align-items-center mb-4 alert alert-danger">
                                  {errorMessage}
                                </div>
                              )}

                              <div className="d-flex justify-content-center mx-4 mb-3 mb-lg-4">
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-lg"
                                >
                                  Log In
                                </button>
                              </div>
                              <p className="text-center text-muted mt-5 mb-0">
                                Don't have an account?{" "}
                                <a href="/signup" className="fw-bold text-body">
                                  <u>Register here</u>
                                </a>
                              </p>
                            </form>
                          </div>
                          <div className="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">
                            <img
                              src={displayPicture}
                              className="img-fluid"
                              alt="Login"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    </>
  );
}

export default Login;
